import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { AppRoutingModule } from './app-routing.module';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatIconModule } from '@angular/material/icon';
import { MatCardModule } from '@angular/material/card';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatTabsModule } from '@angular/material/tabs';

// Interceptors
import { ErrorInterceptor } from './core/interceptors/error.interceptor';

import { AppComponent } from './app.component';
import { AuthModalComponent } from './components/auth-modal/auth-modal.component';
import { PdfViewerModule } from 'ng2-pdf-viewer';
import { LoaderComponent } from './components/loader/loader.component';
import { SharedModule } from './components/shared/shared.module';
import { CertificateInfoModalComponent } from './components/certificate-info-modal/certificate-info-modal.component';
import { SelectCertificateTypeModalComponent } from './components/select-certificate-type-modal/select-certificate-type-modal.component';
import { UploadP12ModalComponent } from './components/upload-p12-modal/upload-p12-modal.component';
import { NgxSpinnerModule } from 'ngx-spinner';
import { MainWorkspaceComponent } from './components/main-workspace/main-workspace.component';
import { LoadingComponent } from './components/loading/loading.component';
import { SignedFilesModalComponent } from './components/signed-files-modal/signed-files-modal.component';
import { PdfPreviewModalComponent } from './components/pdf-preview-modal/pdf-preview-modal.component';
import { AppShellComponent } from './components/app-shell/app-shell.component';
import { TokenFisicoCertificateModalComponent } from './components/token-fisico-certificate-modal/token-fisico-certificate-modal.component';
import { PadesSignatureZoneModalComponent } from './components/pades-signature-zone-modal/pades-signature-zone-modal.component';
import { PadesSignatureImageChoiceModalComponent } from './components/pades-signature-image-choice-modal/pades-signature-image-choice-modal.component';
import { TokenFisicoAdminComponent } from './components/token-fisico-admin/token-fisico-admin.component';
import { DescargarCertificadoComponent } from './components/descargar-certificado/descargar-certificado.component';
import { TokenContentResultModalComponent } from './components/token-content-result-modal/token-content-result-modal.component';
import { TokenFisicoPinDialogComponent } from './components/token-fisico-pin-dialog/token-fisico-pin-dialog.component';
import { TokenFisicoSelectCertForResetComponent } from './components/token-fisico-select-cert-for-reset/token-fisico-select-cert-for-reset.component';
import { TokenFisicoOtpChannelModalComponent } from './components/token-fisico-otp-channel-modal/token-fisico-otp-channel-modal.component';
import { TokenFisicoValidateOtpModalComponent } from './components/token-fisico-validate-otp-modal/token-fisico-validate-otp-modal.component';
import { AlmacenCertificadosComponent } from './components/almacen-certificados/almacen-certificados.component';
import { LocalAgentUnavailablePanelComponent } from './components/local-agent-unavailable-panel/local-agent-unavailable-panel.component';
import { SignatureValidationModalComponent } from './components/signature-validation-modal/signature-validation-modal.component';
import { RseAuthModalComponent } from './components/rse-auth-modal/rse-auth-modal.component';
import { TokenFisicoAlertModalComponent } from './components/token-fisico-alert-modal/token-fisico-alert-modal.component';
import { TokenVirtualAdminComponent } from './components/token-virtual-admin/token-virtual-admin.component';
import { AdminHubComponent } from './components/admin-hub/admin-hub.component';
import { AdminDownloadPanelComponent } from './components/admin-download-panel/admin-download-panel.component';
import { AdminJoinKeysComponent } from './components/admin-join-keys/admin-join-keys.component';
import { GestionHubComponent } from './components/gestion-hub/gestion-hub.component';
import { GestionPlaceholderComponent } from './components/gestion-placeholder/gestion-placeholder.component';
import { GestionEstadoTramiteComponent } from './components/gestion-estado-tramite/gestion-estado-tramite.component';
import { CcswAuthCallbackComponent } from './components/ccsw-auth-callback/ccsw-auth-callback.component';
import { TourComponent } from './components/tour/tour.component';
import { StepIdentificacionComponent } from './components/token-virtual-admin/steps/step-identificacion/step-identificacion.component';
import { StepVerificacionComponent } from './components/token-virtual-admin/steps/step-verificacion/step-verificacion.component';
import { StepCodigoComponent } from './components/token-virtual-admin/steps/step-codigo/step-codigo.component';
import { StepCertificadosComponent } from './components/token-virtual-admin/steps/step-certificados/step-certificados.component';
import { StepCambioContrasenaComponent } from './components/token-virtual-admin/steps/step-cambio-contrasena/step-cambio-contrasena.component';
import { StepExitoComponent } from './components/token-virtual-admin/steps/step-exito/step-exito.component';

@NgModule({
  declarations: [
    AppComponent,
    AppShellComponent,
    LocalAgentUnavailablePanelComponent,
    SignatureValidationModalComponent,
    RseAuthModalComponent,
    TokenFisicoAlertModalComponent,
    TokenFisicoAdminComponent,
    DescargarCertificadoComponent,
    TokenVirtualAdminComponent,
    AdminHubComponent,
    AdminDownloadPanelComponent,
    GestionHubComponent,
    GestionPlaceholderComponent,
    CcswAuthCallbackComponent,
    TourComponent,
    StepIdentificacionComponent,
    StepVerificacionComponent,
    StepCodigoComponent,
    StepCertificadosComponent,
    StepCambioContrasenaComponent,
    StepExitoComponent,
    TokenContentResultModalComponent,
    TokenFisicoPinDialogComponent,
    TokenFisicoSelectCertForResetComponent,
    TokenFisicoOtpChannelModalComponent,
    TokenFisicoValidateOtpModalComponent,
    AlmacenCertificadosComponent,
    AuthModalComponent,
    TokenFisicoCertificateModalComponent,
    PadesSignatureZoneModalComponent,
    PadesSignatureImageChoiceModalComponent,
    LoaderComponent,
    CertificateInfoModalComponent,
    SelectCertificateTypeModalComponent,
    UploadP12ModalComponent,
    MainWorkspaceComponent,
    LoadingComponent,
    SignedFilesModalComponent,
    PdfPreviewModalComponent
  ],
  imports: [
    BrowserModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    MatTabsModule,
    MatDialogModule,
    MatButtonModule,
    MatInputModule,
    MatListModule,
    MatIconModule,
    MatCardModule,
    MatToolbarModule,
    MatProgressSpinnerModule,
    PdfViewerModule,
    SharedModule,
    NgxSpinnerModule.forRoot({ type: 'ball-scale-multiple' }),
    AdminJoinKeysComponent,
    GestionEstadoTramiteComponent

  ],
  providers: [
    // HTTP Interceptor para manejo centralizado de errores
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ErrorInterceptor,
      multi: true
    }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
